import { auth } from '@/auth'
import { dayjs } from '@/services/dayjs'

export default function authMiddleware({ next, router }) {
	if (!auth.value || !auth.value.token) {
		return router.push({ name: 'go.login' })
	}

	const expired = auth.value.expiresAt && dayjs(auth.value.expiresAt).isBefore(dayjs())

	if (expired) {
		return router.push({ name: 'go.login' })
	}

	return next()
}
